import { ContentWrapper } from "@/components/layout/content";

export function Footer() {
  return (
    <footer className="bg-gray-950 border-t border-gray-900 py-12 font-mono text-xs text-gray-500">
      <ContentWrapper>
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-2">
            <span className="text-emerald-400">© 2026</span> loch-im-baum.de // Root access granted.
          </div>

          <div className="flex items-center gap-6">
            <a
              href="#"
              className="hover:text-emerald-400 transition-colors flex items-center gap-2 group"
            >
              <svg
                className="w-4 h-4 group-hover:stroke-emerald-400"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
              </svg>
              GitHub
            </a>
            <a
              href="#"
              className="hover:text-cyan-400 transition-colors flex items-center gap-2 group"
            >
              <svg
                className="w-4 h-4 group-hover:stroke-cyan-400"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                <rect x="2" y="9" width="4" height="12"></rect>
                <circle cx="4" cy="4" r="2"></circle>
              </svg>
              LinkedIn
            </a>
            <a
              href="#"
              className="hover:text-purple-400 transition-colors flex items-center gap-2 group"
            >
              <svg
                className="w-4 h-4 group-hover:stroke-purple-400"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                <circle cx="12" cy="13" r="4"></circle>
              </svg>
              Photography
            </a>
          </div>

          <div className="flex gap-6">
            <a
              href="#"
              className="hover:text-gray-300 transition-colors relative before:content-['>'] before:text-emerald-400 before:absolute before:-left-3 before:opacity-0 hover:before:opacity-100"
            >
              Impressum
            </a>
            <a
              href="#"
              className="hover:text-gray-300 transition-colors relative before:content-['>'] before:text-emerald-400 before:absolute before:-left-3 before:opacity-0 hover:before:opacity-100"
            >
              Datenschutz
            </a>
          </div>
        </div>
      </ContentWrapper>
    </footer>
  );
}
